module.exports = __webpack_public_path__ + "static/img/article1@2x.ae9f634a.png";